export default __webpack_public_path__ + "static/media/primeinitiative.0b23dbfa.png";